import apiClient from './client';

/**
 * Fetch dashboard data (child info, activities, stats)
 */
export const fetchDashboard = async () => {
  console.log('[KidDashboard API] fetchDashboard called');
  try {
    const response = await apiClient.get('/dashboard');
    console.log('[KidDashboard API] fetchDashboard success, child:', response.data?.child?.name);
    return response.data;
  } catch (error) {
    console.log('[KidDashboard API] fetchDashboard error:', error.message);
    throw error;
  }
};

/**
 * Fetch progress data (30-day XP history)
 */
export const fetchProgress = async () => {
  console.log('[KidDashboard API] fetchProgress called');
  try {
    const response = await apiClient.get('/progress');
    console.log('[KidDashboard API] fetchProgress success');
    return response.data;
  } catch (error) {
    console.log('[KidDashboard API] fetchProgress error:', error.message);
    throw error;
  }
};
